/**
 * lower case
 * normalize to decompose combined letters (á, é, ú) into simpler ones á -> a + ´
 * replace with '' all diacritics (like ´ or ¨) within the range of U+0300 to U+036F range
 * @param {string} string
 */
export default function cleanString(string) {
  return string.toLowerCase().normalize('NFD').replace(/[\u0299-\u036f]/g, '');
}
